import { TicketOfficeView } from '../../../types/ticket-office';
import { TicketSystem, TicketSystemProps } from '../../components/TicketSystem';

export const getTicketSystemProps = (view: TicketOfficeView): TicketSystemProps | undefined => {
    const { state } = view;
    const { event } = state;

    return {
        ticketSystem: {
            type: event.ticketSystem.type,
            url: event.ticketSystem.url,
            externalTicketsInfoTitle: event.ticketSystem.externalTicketsInfoTitle,
            externalTicketsInfoA: event.ticketSystem.externalTicketsInfoA,
            externalTicketsInfoB: event.ticketSystem.externalTicketsInfoB,
        },
    };
};
